const install = (_, { onLoadCallback }) => {
    const script = document.createElement("script");
    script.src = "https://product-gallery.cloudinary.com/all.js";
    script.onload = onLoadCallback;
    document.head.appendChild(script);
};
const plugin = { install };
export default plugin;
//# sourceMappingURL=index.js.map